// extracted by mini-css-extract-plugin
export var banner = "_eb-0";
export var closeButton = "_eb-2";
export var greenCheckmark = "_eb-3";
export var hereLink = "_eb-4";
export var titleIcon = "_eb-1";